<template>
    <div class="col-sm-12"
         @mouseover="isMouseOver = true" @mouseout="isMouseOver = false" @click="onColumnClick"
         :class="isMouseOver || column.selected ? selectedClasses : defaultClasses">

        <!-- for apps -->
        <Container v-if="view" :orientation="orientation" :should-accept-drop="shouldAcceptDrop" @drop="onDrop('columnItems', $event)"
                   class="h-100 d-flex" :class="columnClasses">

            <component-container v-for="(component, columnIndex) in column.value" :component="component" :column="column"
                                 :layout="layout" :key="componentKey(columnIndex)"
                                 @columnRefresh="onColumnRefresh"
                                 @iconClick="onEditIcon"
                                 @imageClick="onEditImage"
                                 :view="view"></component-container>
        </Container>

        <!-- for web pages -->
        <Container v-else :orientation="orientation" :should-accept-drop="shouldAcceptDrop" @drop="onDrop('columnItems', $event)"
                   class="h-100 d-flex" :class="columnClasses">

            <element-container v-for="(component, columnIndex) in column.value" :component="component" :column="column"
                              :layout="layout" :key="componentKey(columnIndex)"
                               default-classes="d-flex element-container position-relative"
                               @columnRefresh="onColumnRefresh"
                               @editText="onEditText"
                               @iconClick="onEditIcon"
                               @imageClick="onEditImage"></element-container>
        </Container>

        <icon-modal v-if="showIconModal" @noEvent="showIconModal = false" :yesEvent="iconSelected"></icon-modal>

        <image-modal v-if="showImageModal" @noEvent="showImageModal = false" :page="page" :view="view" :website="model.website"
                     :yesEvent="imageSelected" key="blockImageModal"></image-modal>

        <rich-text-modal v-if="showTextModal" @noEvent="showTextModal = false" :component="layout.selectedComponent"></rich-text-modal>

    </div>
</template>

<script>
    import {Container} from "vue3-smooth-dnd"
    import ComponentContainer from "./ComponentContainer.vue";
    import ElementContainer from "../page/ElementContainer.vue";
    import UIUtil from "../../utils/UIUtil";
    import IconModal from "../page/IconModal.vue";
    import PageFactory from "../../utils/PageFactory";
    import ImageModal from "../page/ImageModal.vue";
    import ComponentUtil from "../../utils/ComponentUtil";
    import RichTextModal from "../page/RichTextModal.vue";

    export default {
        name: 'ColumnContainer',
        props: ['layout', 'row', 'index', 'document', 'column', 'view', 'page'],
        components: {
            RichTextModal,
            ImageModal,
            IconModal,
            ElementContainer,
            ComponentContainer,
            Container
        },
        data() {
            return {
                model: webase.model,
                isMouseOver: false,
                uiUtil: new UIUtil(),
                componentUtil: new ComponentUtil(),
                pageFactory: new PageFactory(),
                showIconModal: false,
                iconSelected: function (icon) {
                },
                showImageModal: false,
                imageSelected: function (image) {
                },
                showTextModal: false
            }
        },
        computed: {
            columnClasses() {
                return this.justifyClass + ' ' + this.alignClass + ' ' + this.directionClass + ' ' + this.cardClass + ' ' +
                    this.marginClass + ' ' + this.paddingClass
            },
            isColumnOriented() {
                return this.column.direction && this.column.direction === 'column'
            },
            orientation() {
                return this.isColumnOriented ? 'vertical' : 'horizontal'
            },
            directionClass() {
                return this.isColumnOriented ? 'flex-column' : 'flex-row'
            },
            selectedClasses() {
                return 'column-border ' + this.defaultClasses
            },
            defaultClasses() {
                return 'col-md-' + this.column.width
            },
            cardClass() {
                return this.column.includeCard ? 'theme-card p-3' : ''
            },
            justifyClass() {
                return this.isColumnOriented ? this.uiUtil.getJustifyClassColumn(this.column.justify) : this.uiUtil.getJustifyClassRow(this.column.justify)
            },
            alignClass() {
                return this.isColumnOriented ? this.uiUtil.getAlignClassColumn(this.column.align) : this.uiUtil.getAlignClassRow(this.column.align)
            },
            marginClass() {
                if(!this.column.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.column.margin)
            },
            paddingClass() {
                if(!this.column.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.column.padding)
            }
        },
        mounted() {
            if(!this.column.margin) {
                this.column.margin = {
                    side: 'none',
                    value: '0'
                }
            }

            if (!this.column.padding) {
                this.column.padding = {
                    side: 'none',
                    value: '0'
                }
            }

            if (!this.column.background) {
                this.column.background = this.pageFactory.defaultBackground()
            }
        },
        methods: {
            onEditText() {
                this.showTextModal = true
            },
            onEditIcon() {
                this.showIconModal = true
                this.iconSelected = (icon) => {
                    this.layout.selectedComponent.value = icon
                }
            },
            onEditImage() {
                this.showImageModal = true
                this.imageSelected = (image) => {
                    this.layout.selectedComponent.value = image
                }
            },
            componentKey(columnIndex) {
                return 'compEditor-' + this.index + columnIndex
            },
            onColumnClick() {
                webase.utils.layout.deselectColumns(this.layout)
                this.column.selected = true
                this.layout.selectedColumn = this.column

                if (this.layout.selectedComponent) {

                    // if selected component is in this column, then return, we are fine
                    for (let k = 0; k < this.column.value.length; k++) {
                        if (this.layout.selectedComponent === this.column.value[k] ||
                            this.componentUtil.isChildComponent(this.column.value[k], this.layout.selectedComponent)) {
                            return
                        }
                    }

                    // if not and we have a component, set it to be selected, otherwise, blank it out
                    if (this.column.value[0]) {
                        this.layout.selectedComponent.selected = false
                        this.layout.selectedComponent = this.column.value[0]
                        this.layout.selectedComponent.selected = true
                    }
                    else {
                        this.layout.selectedComponent.selected = false
                        this.layout.selectedComponent = null
                    }
                }
            },
            onDrop(collection, dropResult) {
                if (dropResult.addedIndex === null) {
                    return
                }

                let payload = dropResult.payload

                if(payload.type === 'Icon') {
                    this.showIconModal = true
                    this.iconSelected = (icon) => {
                        let iconComponent = this.pageFactory.createIconComponent(icon)
                        this.setLabelColor(iconComponent)
                        this.column.value.push(iconComponent)
                        this.layout.selectedComponent = this.column.value[this.column.value.length - 1]
                    }

                    return
                }
                else if(payload.type === 'Image') {
                    this.showImageModal = true
                    this.imageSelected = (image) => {
                        let imageComponent = this.pageFactory.createImageComponent(image)
                        this.column.value.push(imageComponent)
                        this.layout.selectedComponent = this.column.value[this.column.value.length - 1]
                    }

                    return
                }

                if(payload.type === 'InternalRow') {
                    console.log('***** setting parent column on internal row *****')
                    payload.parentColumn = this.column
                }

                this.setLabelColor(payload)
                this.column.value.push(payload)
                this.layout.selectedComponent = this.column.value[this.column.value.length - 1]

                if(payload.type === 'Text') {
                    this.showTextModal = true
                }
            },
            shouldAcceptDrop(sourceContainerOptions, payload) {
                return sourceContainerOptions.groupName !== "rowContainers"
            },
            setLabelColor(component) {

                if(this.row && this.row.background.color && this.row.background.color.indexOf('#') === 0) {
                    let bgColor = this.row.background.color
                    let betterDefaultColor = webase.utils.ui.getOppositeColor(bgColor)

                    if(component.style && component.style.color) {
                        component.style.color = betterDefaultColor
                    }
                }

            },
            onColumnRefresh() {
                this.$forceUpdate()
            }
        }
    }
</script>
